//INFO for type use types util
//INFO for validation use validatorTypes util
//INFO for references type use referenceTypes util
//lucide-react is used for icons; only the icon name needs to be passed.
const { types, referenceTypes, uiTypes } = require("./utils/types");
const { validatorTypes } = require("./utils/validatorTypes");

const models = [
    {
        tableName: "ffAdminUsers",
        read: true,
        create: false,
        edit: false,
        delete: false,
        comments: true, //for enabiling comments on view and edit
        references: [],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "name",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "email",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "email",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "description",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },

            {
                name: "profile_picture",
                type: types.STRING,
                validation: [validatorTypes.url, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.IMAGE, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "slug",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "createdAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    // added for ui
                    type: uiTypes.DATE, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "updatedAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    // added for ui
                    type: uiTypes.DATE, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "deletedAt",
                type: types.DATE,
                allowNull: true,
                defaultValue: null,
                read: false,
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: false,
                    read: false,
                    create: false,
                    edit: false,
                },
            },
        ],
    },
    {
        tableName: "contact",
        read: true,
        create: true,
        edit: true,
        delete: true,
        comments: true, //for enabiling comments on view and edit
        references: [],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "name",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "email",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "email",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "phone",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },

            {
                name: "description",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    // added for ui
                    type: uiTypes.TEXT_AREA, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },

            {
                name: "createdAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    // added for ui
                    type: uiTypes.DATE, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "updatedAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    // added for ui
                    type: uiTypes.DATE, //UI Types
                    validation: [], //UI Validation
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "deletedAt",
                type: types.DATE,
                allowNull: true,
                defaultValue: null,
                read: false,
                ui: {
                    // added for ui
                    type: uiTypes.TEXT, //UI Types
                    validation: [], //UI Validation
                    list: false,
                    read: false,
                    create: false,
                    edit: false,
                },
            },
        ],
    },

    {
        tableName: "blog",
        read: true,
        create: true,
        edit: true,
        delete: true,
        comments: true, //for enabiling comments on view and edit
        references: [
            {
                tableName: "blog_category",
                foreignKey: "category_id",
                primaryKey: "id",
                type: referenceTypes.MANY_TO_MANY,
                displayKey: "name",
            },
            {
                tableName: "ffAdminUsers",
                foreignKey: "ff_admin_user_id",
                primaryKey: "id",
                type: referenceTypes.ONE,
                displayKey: "name",
            },
        ],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "ff_admin_user_id",
                type: types.UUID,
                allowNull: true,
                isArray: false,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    type: uiTypes.DROPDOWN,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "category_id",
                type: types.STRING,
                allowNull: true,
                isArray: true,
                validation: [validatorTypes.array, validatorTypes.optional],
                ui: {
                    type: uiTypes.DROPDOWN_MULTISELECT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "title",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "sub_title",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "description",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT_AREA,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "meta_title",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT_AREA,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "meta_description",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT_AREA,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "meta_keywords",
                type: types.STRING,
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT_AREA,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "portrait_card_image",
                type: types.STRING,
                allowNull: false,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.DOCUMENT,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "portrait_card_image_alt_text",
                type: types.STRING,
                allowNull: false,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "blogs_details_image",
                type: types.STRING,
                allowNull: false,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.DOCUMENT,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "blogs_details_image_alt_text",
                type: types.STRING,
                allowNull: false,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },

            {
                name: "content_section",
                type: types.JSONB,
                allowNull: false,
                validation: [validatorTypes.json, validatorTypes.required],
                isArray: true,
                ui: {
                    type: uiTypes.EDITOR,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "slug",
                type: types.STRING,
                allowNull: false,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "date_of_published",
                type: types.DATE,
                validation: [validatorTypes.date, validatorTypes.optional],
                ui: {
                    type: uiTypes.DATE,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "number_of_images",
                type: types.INTEGER,
                validation: [validatorTypes.number, validatorTypes.optional],
                ui: {
                    type: uiTypes.NUMBER,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "time_of_the_video",
                type: types.DOUBLE,
                validation: [validatorTypes.number, validatorTypes.optional],
                ui: {
                    type: uiTypes.NUMBER,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "date_of_update",
                type: types.DATE,
                validation: [validatorTypes.date, validatorTypes.optional],
                ui: {
                    type: uiTypes.DATE,
                    validation: [],
                    list: false,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "published",
                type: types.BOOLEAN,
                defaultValue: false,
                validation: [validatorTypes.boolean, validatorTypes.optional],
                ui: {
                    type: uiTypes.CHECKBOX,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "status",
                type: types.ENUM,
                enumValues: ["draft", "submitted", "approved"],
                defaultValue: "draft",
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.DROPDOWN,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                    menuTopPlacement: true,
                },
            },
            {
                name: "featured_post",
                type: types.BOOLEAN,
                defaultValue: false,
                validation: [validatorTypes.boolean, validatorTypes.optional],
                ui: {
                    type: uiTypes.CHECKBOX,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "read_time",
                type: types.DOUBLE,
                validation: [validatorTypes.number, validatorTypes.optional],
                ui: {
                    type: uiTypes.NUMBER,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "createdAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    type: uiTypes.DATE,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "updatedAt",
                type: types.DATE,
                allowNull: false,
                defaultValue: null,
                ui: {
                    type: uiTypes.DATE,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "deletedAt",
                type: types.DATE,
                allowNull: true,
                defaultValue: null,
                read: false,
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: false,
                    read: false,
                    create: false,
                    edit: false,
                },
            },
        ],
    },

    {
        tableName: "blog_category",
        read: true,
        create: true,
        edit: true,
        delete: true,
        comments: true, //for enabiling comments on view and edit
        references: [],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "name",
                type: types.STRING,
                allowNull: true,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
            {
                name: "status",
                type: types.ENUM,
                enumValues: ["draft", "active", "inactive"],
                defaultValue: "draft",
                validation: [validatorTypes.string, validatorTypes.optional],
                ui: {
                    type: uiTypes.DROPDOWN,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
        ],
    },
    {
        tableName: "newsletter",
        read: true,
        create: true,
        edit: true,
        delete: true,
        comments: true, //for enabiling comments on view and edit
        references: [],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "email",
                type: types.STRING,
                allowNull: true,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
        ],
    },

    {
        tableName: "images",
        read: true,
        create: true,
        edit: true,
        delete: true,
        comments: true, //for enabiling comments on view and edit
        references: [],
        icon: "Database",
        columns: [
            {
                name: "id",
                type: types.UUID,
                allowNull: false,
                defaultValue: types.UUIDV4,
                primaryKey: true,
                validation: [validatorTypes.uuid, validatorTypes.optional],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: false,
                    edit: false,
                },
            },
            {
                name: "path",
                type: types.STRING,
                allowNull: true,
                validation: [validatorTypes.string, validatorTypes.required],
                ui: {
                    type: uiTypes.TEXT,
                    validation: [],
                    list: true,
                    read: true,
                    create: true,
                    edit: true,
                },
            },
        ],
    },
];

module.exports = models;
